var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.6713C8.933 17.6713 10.5 16.1043 10.5 14.1713C10.5 12.2383 8.933 10.6713 7 10.6713C5.067 10.6713 3.5 12.2383 3.5 14.1713C3.5 16.1043 5.067 17.6713 7 17.6713Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 25.5463C21.183 25.5463 22.75 23.9793 22.75 22.0463C22.75 20.1133 21.183 18.5463 19.25 18.5463C17.317 18.5463 15.75 20.1133 15.75 22.0463C15.75 23.9793 17.317 25.5463 19.25 25.5463Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 9.79626C21.183 9.79626 22.75 8.22926 22.75 6.29626C22.75 4.36327 21.183 2.79626 19.25 2.79626C17.317 2.79626 15.75 4.36327 15.75 6.29626C15.75 8.22926 17.317 9.79626 19.25 9.79626Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3058 8.18896L9.94336 12.2791",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94336 16.0635L16.3058 20.1536",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareV2);
export default __webpack_public_path__ + "static/media/share_v2.ad8910f20076445ee5e4001cbea0554a.svg";
export { ForwardRef as ReactComponent };